import { render, staticRenderFns } from "./card-item.vue?vue&type=template&id=a863ac34&scoped=true"
import script from "./card-item.vue?vue&type=script&lang=js"
export * from "./card-item.vue?vue&type=script&lang=js"
import style0 from "./card-item.vue?vue&type=style&index=0&id=a863ac34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a863ac34",
  null
  
)

export default component.exports